import React, { useState, useEffect } from "react";
import Select from "react-select";
import "./PlayerPaymentDetail.css";
import { useLocation,useSearchParams} from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import Swal from "sweetalert2";
const GST_PERCENTAGE = 18;  
const AddPlayerPayment = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const batchId = searchParams.get("batchId");
  const playerId = searchParams.get("playerId");
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setrowsPerPage] = useState(10);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const [players, setPlayers] = useState([]);
  const [batchName, setBatchName] = useState("");
  const [monthlyFees, setMonthlyFees] = useState("");
  const [paymentTerms, setPaymentTerms] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const token = localStorage.getItem('auth-token');
  const handleItemsPerPageChange = (event) => {
    setrowsPerPage(Number(event.target.value));
    setCurrentPage(1);
  };
  useEffect(() => {
    const fetchPlayers = async () => {
      setLoading(true);
      setError(null);

      try {
        let response;
  
        if (batchId && playerId) {
          const playerIds = Array.isArray(playerId) ? playerId.join(',') : playerId;
          response = await fetch(
            `${process.env.REACT_APP_API_ENABLE_PLAYER}?batch_id=${batchId}&playerIds=${playerIds}`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${token}`,
              }
            } 
          ); 
  
        const result = await response.json();

  
          if (result.success) {
            setBatchName(result.data.batch.name);
            setMonthlyFees(result.data.batch.monthlyFees);
            setPaymentTerms(
              result.data.batchPaymentTerms.map((term) => ({
                value: term,
                label: term,
              }))
            );
  
          const playersData = result.data.playerBatchAddForm.batchPaymentDetailsForms.map(
            (player) => {
              const baseTotal = player.total;
              const total = player.gstApplicable
                ? (baseTotal * (100 + GST_PERCENTAGE)) / 100    
                : baseTotal;
  
              return {
                id: player.id,
                playerId: player.playerId,
                name: player.playerName,
                weeklySessions: player.weeklySessions,
                finalMonthlyFees: player.finalMonthlyFee,
                extraFee: player.joiningFee,
                baseTotal,                                  
                total,                                          
                canAddJoiningFee: player.canAddJoiningFee,
                dateOfJoining: player.joiningDate.split("T")[0],
                dateOfNextPayment: player.nextPaymentDueDate.split("T")[0],
                term: player.term,
                gstApplicable: player.gstApplicable,
                isEdited: false,
              };
            }
          );
  
            setPlayers(playersData);
          } else {
          }
        }
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };
  
    if (batchId) fetchPlayers();
  }, [batchId, playerId]);
  const TERM_MULTIPLIERS = {
    monthly: 1,
    bimonthly: 2,
    quarterly: 3,
    semi_annual: 6,
    annual: 12
  };
  
  const handleInputChange = (index, field, value) => {
    const updated = [...players];
    updated[index][field] = value;
  
    const multiplier = TERM_MULTIPLIERS[updated[index].term?.toLowerCase()] || 1;
    const monthlyFee = parseFloat(updated[index].finalMonthlyFees || monthlyFees) || 0;
    const extraFee = parseFloat(updated[index].extraFee) || 0;
    const baseTotal = monthlyFee * multiplier + extraFee;
  
    updated[index].baseTotal = baseTotal;
    updated[index].total = updated[index].gstApplicable
      ? (baseTotal * (100 + GST_PERCENTAGE)) / 100
      : baseTotal;
  
    const editableFields = [
      "finalMonthlyFees",
      "extraFee",
      "weeklySessions",
      "dateOfJoining",
      "dateOfNextPayment",
    ];
    if (editableFields.includes(field)) {
      updated[index].isEdited = true;
    }
  
    setPlayers(updated);
  };

  const handleGstChange = (index) => {
    const updated = [...players];
    const wasChecked = updated[index].gstApplicable;
    updated[index].gstApplicable = !wasChecked;
    if (!wasChecked) {
      updated[index].total = updated[index].total * (100 + GST_PERCENTAGE) / 100;
    } else {
      updated[index].total = updated[index].total * 100 / (100 + GST_PERCENTAGE);
    }
  
    updated[index].isEdited = true;
    setPlayers(updated);
  };
  

  const handleTermChange = (index, selectedOption) => {
    const updated = [...players];
    const term = selectedOption.value;
    updated[index].term = term;
  
    const multiplier = TERM_MULTIPLIERS[term.toLowerCase()] || 1;
    const monthlyFee = parseFloat(updated[index].finalMonthlyFees || monthlyFees) || 0;
    const extraFee = parseFloat(updated[index].extraFee) || 0;
    const baseTotal = monthlyFee * multiplier + extraFee;
  
    updated[index].baseTotal = baseTotal;
    updated[index].total = updated[index].gstApplicable
      ? (baseTotal * (100 + GST_PERCENTAGE)) / 100
      : baseTotal;
  
    updated[index].isEdited = true;
    setPlayers(updated);
  };

  const filteredPlayers = players.filter((p) =>
    p.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleSort = (columnKey) => {
    let direction = "ascending";
    if (sortConfig.key === columnKey && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    setSortConfig({ key: columnKey, direction });
  };

  const sortData = (data) => {
    const { key, direction } = sortConfig;
    return [...data].sort((a, b) => {
      let aVal = a[key];
      let bVal = b[key];
      if (!isNaN(aVal) && !isNaN(bVal)) {
        aVal = Number(aVal);
        bVal = Number(bVal);
      }
      if (aVal < bVal) return direction === "ascending" ? -1 : 1;
      if (aVal > bVal) return direction === "ascending" ? 1 : -1;
      return 0;
    });
  };


  const handlePageClick = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const sortedData = sortData(filteredPlayers);
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = sortedData.slice(indexOfFirstRow, indexOfLastRow);
  const totalPages = Math.ceil(sortedData.length / rowsPerPage);

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage((prevPage) => prevPage + 1);
  };

  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage((prevPage) => prevPage - 1);
  };

  const generatePageNumbers = () => {
    const pages = [];
    const totalPagesToShow = 5;

    if (totalPages <= totalPagesToShow) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      if (currentPage > 2) pages.push(1, "...");
      for (let i = Math.max(2, currentPage - 1); i <= Math.min(totalPages - 1, currentPage + 1); i++) {
        pages.push(i);
      }
      if (currentPage < totalPages - 1) pages.push("...", totalPages);
    }
    return pages;
  };


  const renderPagination = () => {
    return generatePageNumbers().map((page, index) =>
      typeof page === 'number' ? (
        <button
          key={index}
          className={`page-number ${currentPage === page ? 'active' : ''}`}
          onClick={() => handlePageClick(page)}
        >
          {page}
        </button>
      ) : (
        <span key={index} className="pagination-dots">
          {page}
        </span>
      )
    );
  };

  const totalEntries = filteredPlayers.length;
  const indexOfFirstEntry = totalEntries > 0 ? (currentPage - 1) * rowsPerPage + 1 : 0;
  const indexOfLastEntry = totalEntries > 0 ? Math.min(currentPage * rowsPerPage, totalEntries) : 0;
  const handleDoneClick = () => {
    const selectedPlayers = players.map((p) => ({
      id: p.id,
      playerId: p.playerId,
      playerName: p.name,
      finalMonthlyFee: p.finalMonthlyFees,
      total: p.total,
      canAddJoiningFee: p.canAddJoiningFee, 
      joiningFee: p.extraFee,
      joiningDate: new Date(p.dateOfJoining).toISOString(),
      nextPaymentDueDate: p.dateOfNextPayment,
      discount: 0.0,
      term: p.term,
      weeklySessions: p.weeklySessions, 
      gstApplicable: p.gstApplicable,
    }));
    

    const payload = { batchId, batchPaymentDetailsForms: selectedPlayers };


    fetch(process.env.REACT_APP_API_ADD_PLAYER_PAYMENT, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    })
      .then((res) => {
        return res.json().then((data) => {
          if (!res.ok || data.success === false) {
            throw new Error(data?.data?.errorMessage || "Unknown error occurred");
          }
          return data;
        });
      })
      .then(() => {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Payment Added Successfully",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
        });
        navigate(-1);
      })
      .catch((err) => {
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: err.message,
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
        });
        console.error("Error submitting data:", err);
      });    
  };

  return (
    <div className="enrollment-container">
      <div className="search-bar">
        <div className="input-container">
          <input
            type="text"
            id="searchInput"
            className={`search-input ${searchTerm ? "has-value" : ""}`}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <label htmlFor="searchInput" className="floating-label">
            🔍 Search
          </label>
        </div>
        <button className="create-button" onClick={handleDoneClick}>
          Done
        </button>
      </div>

      <div className="items-and-dues">
        <select className="items-per-page-select" value={rowsPerPage} onChange={handleItemsPerPageChange}>
          <option value={10}>10 items per page</option>
          <option value={50}>50 items per page</option>
          <option value={75}>75 items per page</option>
        <option value={100}>100 items per page</option>
      </select>
      <div className="pagination-selector">
          <div className="button-group">
            <div className="group-label">Items per page:</div>
            <div className="button-options">
              {[10, 50, 75, 100].map((option) => (
                <button
                  key={option}
                  onClick={() =>
                    handleItemsPerPageChange({ target: { value: option } })
                  }
                  className={`page-button ${rowsPerPage === option ? 'active' : ''}`}
                >
                  <span className="button-text">{option}</span>
                </button>
              ))}
            </div>
          </div>
        </div>
        <div className="total-dues">
          <div>
            <strong>Batch: {batchName}</strong></div>
          <strong>Monthly Fees: ₹{monthlyFees}</strong>
        </div>
      </div>
      {loading && (
        <div className="premium-loader">
          <div className="progress-track">
            <div className="progress-bar"></div>
          </div>
          <div className="status-text">
            <span>L</span>
            <span>O</span>
            <span>A</span>
            <span>D</span>
            <span>I</span>
            <span>N</span>
            <span>G</span>
          </div>
        </div>
      )}
      {error && <div className="error-message">{error}</div>}
      {!loading && !error && filteredPlayers.length === 0 && (
        <div className="error-message">No data available</div>
      )}
        <div style={{overflow:'scroll'}}>
      <table className="cancel-batch-table">
        <thead>
          <tr>
            <th className="challenges-column">GST Applicable</th>
            <th className="challenges-columnr">Name</th>
            <th className="challenges-column">Date of Joining</th>
            <th className="challenges-column">Date of Next Payment</th>
            <th className="challenges-column">Final Monthly Fees</th>
            <th className="challenges-column">Term</th>
            <th className="challenges-column">Extra Fee</th>
            <th className="challenges-column">Total</th>
          </tr>
        </thead>
        <tbody>
  {currentRows.map((player, index) => {
    const actualIndex = indexOfFirstRow + index; 
    return (
      <tr key={player.id} className="player-payment-table-row">
        <td className="player-payment-table-cell">
          <input
            type="checkbox"
            checked={player.gstApplicable}
            onChange={() => handleGstChange(actualIndex)}
            className="player-payment-checkbox"
          />
        </td>
        <td className="player-payment-table-cell">{player.name}</td>

        <td className="player-payment-table-cell">
          <input
            type="date"
            value={player.dateOfJoining}
            onChange={(e) =>
              handleInputChange(actualIndex, "dateOfJoining", e.target.value)
            }
            className="player-payment-input"
          />
        </td>

        <td className="player-payment-table-cell">
          <input
            type="date"
            value={player.dateOfNextPayment}
            onChange={(e) =>
              handleInputChange(actualIndex, "dateOfNextPayment", e.target.value)
            }
            className="player-payment-input"
          />
        </td>
        <td className="player-payment-table-cell">
          <input
            type="text"
            value={player.finalMonthlyFees}
            onChange={(e) =>
              handleInputChange(actualIndex, "finalMonthlyFees", e.target.value)
            }
            className="player-payment-input"
          />
        </td>
        <td className="player-payment-table-cell">
          <Select
            options={paymentTerms}
            value={paymentTerms.find((term) => term.value === player.term)}
            onChange={(selectedOption) =>
              handleTermChange(actualIndex, selectedOption)
            }
            menuPortalTarget={document.body}
            className="player-payment-dropdown"
          />
        </td>
        <td className="player-payment-table-cell">{player.extraFee}</td>
        <td className="player-payment-table-cell">{player.total}</td>
      </tr>
    );
  })}
</tbody>

      </table>
      </div>
      <div className="pagination">
        <div className="showing-entries">
          Showing {indexOfFirstEntry} to {indexOfLastEntry} of {totalEntries} entries
        </div>
        <button
          className="prev-button"
          onClick={handlePrevPage}
          disabled={currentPage === 1}
        >
          Previous
        </button>
        {renderPagination()}
        <button
          className="next-button"
          onClick={handleNextPage}
          disabled={currentPage === totalPages}
        >
          Next
        </button>
      </div>
    </div>
  );
};



export default AddPlayerPayment
